/**
 * Transform snake_case value from back to camelCase value
 * @param {string} snakeCaseValue
 * @returns {string}
 */
const fromSnakeToCamel = (snakeCaseValue) => {
    return snakeCaseValue
        .toLowerCase()
        .replace(/([-_][a-z])/g, (snakeCasePartToTransform) =>
            snakeCasePartToTransform.toUpperCase().replace('-', '').replace('_', ''),
        );
};
/**
 * Transform snake_case value from back to PascalCase value
 * @param {string} snakeCaseValue
 * @returns {string}
 */
const fromSnakeToPascal = (snakeCaseValue) => {
    return fromSnakeToCamel(snakeCaseValue)
        .split('_')
        .map((word, index) => {
            if (index === 0) return word.charAt(0).toUpperCase() + word.slice(1);
            return word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join('');
};

/**
 * Transform camelCase value to snake_case value
 * @param {string} camelCaseValue
 * @returns {string}
 */
const fromCamelToSnake = (camelCaseValue) => {
    return camelCaseValue.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

/**
 * Convert all keys of an object from camelCase to snake_case
 * @param {Object} obj
 * @returns {Object}
 */
const convertKeysToSnakeCase = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(convertKeysToSnakeCase);
    }
    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
                fromCamelToSnake(key),
                convertKeysToSnakeCase(value),
            ]),
        );
    }
    return obj;
};

/**
 * Convert all keys of an object from snake_case to camelCase
 * @param {Object} obj
 * @returns {Object}
 */
const convertKeysToCamelCase = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(convertKeysToCamelCase);
    }
    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
                fromSnakeToCamel(key),
                convertKeysToCamelCase(value),
            ]),
        );
    }
    return obj;
};

export {
    fromSnakeToCamel,
    fromSnakeToPascal,
    fromCamelToSnake,
    convertKeysToSnakeCase,
    convertKeysToCamelCase,
};
